import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import ReportForm from "@/modules/report/admin/components/ReportForm";
import { fetchReportQueryOptions } from "@/modules/report/admin/services/report";

export const Route = createFileRoute(
  "/admin/_panel/_report/report/reports/$id",
)({
  component: Component,
  parseParams: (params) => ({
    id: z.number().int().parse(Number(params.id)),
  }),
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(context.user, "report.report.update");

    return {
      compactMenu: true,
      hideCrumb: true,
      crumb: [
        {
          label: context.t("Edit report", { ns: "report.admin" }),
        },
      ],
    } satisfies ChildRouteContext;
  },
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      fetchReportQueryOptions(opts.params.id),
    ),
  stringifyParams: ({ id }) => ({ id: `${id}` }),
});

function Component() {
  const { id } = Route.useParams();

  return <ReportForm id={id} />;
}
